import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analyticsPromise } from "../firebase";

export default function AnalyticsTracker() {
  const location = useLocation();
  const lastPathRef = useRef("");

  useEffect(() => {
    const track = async () => {
  try {
    if (typeof window === "undefined") return;

    const analytics = await analyticsPromise;
    if (!analytics) return;

    const path = location.pathname + location.search;

    if (lastPathRef.current === path) return;
    lastPathRef.current = path;

    logEvent(analytics, "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title:
        typeof document !== "undefined" ? document.title : "",
      debug_mode: process.env.NODE_ENV === "development",
    });
  } catch (e) {
    console.warn("Analytics tracking failed:", e);
  }
};

    track();
  }, [location]);

  return null;
}